import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor() { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        // Get the token from localStorage
        const token = localStorage.getItem('sb-token');

        if (token) {
            try {
                // Parse the token to get the actual bearer token
                const tokenData = JSON.parse(token);
                const accessToken = tokenData?.access_token;

                if (accessToken) {
                    // Clone and modify the request to include the auth token
                    request = request.clone({
                        setHeaders: {
                            Authorization: `Bearer ${accessToken}`
                        }
                    });
                }
            } catch (error) {
                console.error('Error parsing auth token', error);
            }
        }

        return next.handle(request);
    }
}
